import {Component, Output, Input, EventEmitter, OnInit} from '@angular/core';

import { ApplicationContext } from '../model/application-context';

@Component({
    selector: 'data-navbar',
    template: `
      <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <button class="btn btn-primary" id="menu-toggle" onclick="toggleSideBar()"><span class="fas fa-bars"></span></button>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="topNavBar collapse navbar-collapse" id="navbarSupportedContent">
          <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarNavDropdown">
            <ul class="navbar-nav">
              <li class="nav-item">
                <button class="btn btn-outline-warning my-2 my-sm-0" [class.active]="appContext.dataNavigationState.selectedView == 'home'" (click)="onNavbarClick('home')"><img alt="homeIcon" class="homeIcon" src="../../assets/images/259.png"></button>
                <div></div>
              </li>
              <li class="nav-item">
                <button class=" respBtn btn btn-outline-dark my-2 my-sm-0" [class.active]="appContext.dataNavigationState.selectedView == 'respondents'" (click)="onNavbarClick('respondents')"><span><i style="margin-right: 10px;" class="fas fa-users"></i></span>{{'respondents'|translate}}</button>
                <div></div>
              </li>
              <li class="nav-item" >
                <button class="statBtn btn btn-outline-primary my-2 my-sm-0" [class.active]="appContext.dataNavigationState.selectedView == 'stats'" (click)="onNavbarClick('stats')"><span><i style="margin-right: 10px;" class="fas fa-chart-line"></i></span>{{'statistics'|translate}}</button>
                <div></div>
              </li>
                <li *ngIf="appContext.dataNavigationState.selectedView!='report'&& appContext.dataNavigationState.selectedView!='htmlRapport'" class="nav-item" >
                    <button class="reportBtn btn btn-outline-success my-2 my-sm-0" [class.active]="appContext.dataNavigationState.selectedView == 'report'" (click)="onNavbarClick('report')"><span><i style="margin-right: 10px;" class="fas fa-table"></i></span>{{'report'|translate}}</button>
                    <div></div>
                </li>
              <li *ngIf="appContext.dataNavigationState.selectedView=='htmlRapport'" class="nav-item dropdown">
                <div class="btn-group">
                  <button type="button" class="btn btn-outline-success dropdown-toggle"  (click)="colorChange()" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span><i style="margin-right: 10px;" class="fas fa-download"></i></span>{{'download'|translate}}
                  </button>
                  <div class="dropdown-menu"  aria-labelledby="navbarDropdown">
                      <a (click)="onExcelReport()" class="dropdown-item"><img alt="homeIcon" class="icon" src="../../assets/images/excelIcon.png"> {{'excelReport'|translate}}</a>
                      <a (click)="onHtmlReport()" class="dropdown-item"><img alt="homeIcon" class="icon" src="../../assets/images/analytics.png"> {{'htmlReport'|translate}}</a>
                  </div>
                </div>
              </li>
              <li>
                  <div class=" topInput input-group mb-3" style="border-style: dashed;border-color: #1c71ff;border-width:thin;">
                      <div class="input-group-prepend" style="background-color: #00b0ff;">
                          <span class="input-group-text" id="basic-addon3"><img alt="questionnaireIcon" class="questionnaireIcon" src="../../../assets/images/GoogleFormSmall.png" aria-hidden="true" data-toggle="tooltip" data-placement="bottom" title="Selected Questionnaire"></span>
                      </div>
                      <input  [disabled]="true" type="text" [value]="getSelectedQuestionnaireValue()" style="color: #1c71ff; font-weight: bold;" class="form-control" id="basic-url" aria-describedby="basic-addon3">
                  </div>
              </li>
            </ul>
          </div>
        </div>
      </nav>





<!--  A retirer
      <nav class="navbar navbar-inverse">
                <ul class="nav navbar-nav navbar-left">
                    <li [class.active]="appContext.dataNavigationState.selectedView == 'respondents'">
                        <a class="hand" (click)="onNavbarClick('respondents')">{{'respondents'|translate}}</a>
                        <div></div>
                    </li>
                    <li [class.active]="appContext.dataNavigationState.selectedView == 'stats'">
                        <a class="hand" (click)="onNavbarClick('stats')">{{'statistics'|translate}}</a>
                        <div></div>
                    </li>
                    <li class="dropdown">
                            <a href="#"
                            class="dropdown-toggle"
                            data-toggle="dropdown"
                            role="button"
                            aria-haspopup="true"
                            aria-expanded="false">{{'download'|translate}}</a>
                            <div></div>
                            <ul class="dropdown-menu">
                                <li>
                                    <a (click)="onExcelReport()" class="hand">{{'excelReport'|translate}}</a>
                                </li>
                                <li>
                                    <a (click)="onHtmlReport()" class="hand">{{'htmlReport'|translate}}</a>
                                </li>
                            </ul>
                    </li>
                    <li>
                        <search-filter (filterChange)="onSearchFilterChange($event)" [app-context]="appContext"></search-filter>
                    </li>
                </ul>
        </nav> -->
    `,
  styles:[`
      .topNavBar{margin-top:15px;}
      .topInput{margin-left: 360px;}
      .input-group-prepend{background-color:#245edb;}
      .respBtn,.statBtn,.reportBtn{height:37px;}
      .nav-item{margin-left: 20px;}
  .homeIcon{height:35px;}
  .icon{height:25px;}
  .btn-outline-warning{padding: 0;}
  .dropdown-item{font-size: small;font-family: Verdana;}
  .dropdown-item:hover{background-color:#245edb;color:white;}
  .questionnaireIcon{height: 20px;}
  .experience {
      display: flex;
      align-items: center;
      height: 65px;
      box-shadow: 3px 2px 3px #7fbce8 inset;
      background: linear-gradient(to bottom, #245edb 0%, #0c8dea 100%);
      padding: 8px 0px 7px 8px;}`]
})
export class DataNavbarComponent implements OnInit {
    @Input('app-context') appContext: ApplicationContext;
    @Output()FilterChange: EventEmitter<any> = new EventEmitter();
    @Output()Download: EventEmitter<any> = new EventEmitter();
    @Output()ReportExcel: EventEmitter<any> = new EventEmitter();
    @Output()ReportHtml: EventEmitter<any> = new EventEmitter();
    @Output()CreateTerminal: EventEmitter<any> = new EventEmitter();
    @Output()TerminalSelected: EventEmitter<any> = new EventEmitter();

    private white= false;

    constructor() {
    }

    ngOnInit(): void {
        this.appContext.dataNavigationState.selectedView = 'none';
        this.appContext.dataNavigationState.selectedQuestionnaire = localStorage.getItem('selectedQuestionnaire');
    }

    onSearchFilterChange(searchFilter) {
        this.FilterChange.emit(searchFilter);
    }

    onExcelReport() {
        this.ReportExcel.emit();
    }

    onHtmlReport() {
        this.appContext.dataNavigationState.selectedView = 'htmlRapport';
        this.ReportHtml.emit();
    }

    onDownloadFile(mediaQuestion) {
        this.Download.emit(mediaQuestion);
    }

    onNavbarClick(value) {
        this.appContext.dataNavigationState.selectedView = value;
    }

    onCreateTerminalClick() {
        this.CreateTerminal.emit();
    }

    onTerminalClick(terminal) {
        this.TerminalSelected.emit(terminal);
    }

    colorChange() {
        this.white = !this.white;
    }

    private getSelectedQuestionnaireValue():string {
        return localStorage.getItem('selectedQuestionnaire');
    }
}
